export default __webpack_public_path__ + "static/media/logo-products-chain.8e70c915.svg";